import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class StyleService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getProperties(scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/properties/all')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageStyle(style, isEdit, id = null, scope = 'backoffice') {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/style/' + id, style)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/' + scope + '/style/', style)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getStyle(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/style/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getStyleItem(id, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/style/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null, scope = 'backoffice') {
    return this.http.put<any>(environment.apiUrl + '/' + scope + '/style/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteStyle(id, scope = 'backoffice') {
    return this.http.delete(environment.apiUrl + '/' + scope + '/style/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public reAddStyle(id, scope = 'backoffice') {
    return this.http.put(environment.apiUrl + '/' + scope + '/style/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
